/* Cellar quote UI, shared by the calculator page and the homepage sizing quiz.
 * Inputs are found by data-q inside the form, never by id, because this markup
 * renders twice on a site that must not carry duplicate ids.
 *
 * The alternatives are SELECTABLE (radio), not separate add-to-carts: the
 * recommended unit + rack are pre-selected, and one "Complete quote" block
 * (total, cart link, QR, print) reflects whatever the shopper picks. In-stock
 * options are listed first; out-of-stock ones sort to the bottom and are badged.
 *
 * ADD-ONS. When a unit is selected we surface the accessories that actually fit
 * it (ducting kit, exterior grill, UV-C, condensate pump, etc.) as optional
 * checkboxes. Accessories in this catalogue are model-specific, so we match by
 * brand + model number + series rather than showing the whole shelf: a ducting
 * kit for the wrong model is worse than none on a tool that sells on accuracy.
 * Maintenance parts (filters, bulbs) and items whose variants are functional
 * choices rather than fitment (e.g. Breezaire "Unit Modification") are excluded.
 */
(function (root) {
  'use strict';
  var CAT = null;

  function data() {
    if (CAT) return CAT;
    var el = document.getElementById('wcc-quote-data');
    if (!el) return null;
    try { CAT = JSON.parse(el.textContent); } catch (e) { CAT = null; }
    return CAT;
  }
  function money(n) { return '$' + Number(n).toLocaleString('en-US', { maximumFractionDigits: 0 }); }
  /* The page restamps its BTU figure with the full heat-load total from
   * wcc-load-detail. Carry the same number here, or this output contradicts
   * the page it came from. Falls back to the old estimate when the detail
   * snippet is not on the page. */
  function loadBtu(q) {
    try {
      if (typeof root.WCCLoadTotal === 'function') {
        var t = root.WCCLoadTotal();
        if (t != null && isFinite(t)) return Math.round(t);
      }
    } catch (e) {}
    return (q && q.btu) || 0;
  }
  // Fire a GA4 event via gtag if present (funnel measurement for the calculator).
  function gev(name, params) { try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) {} }
  // Side-by-side comparison of the top recommended cooling units, so the shopper
  // can weigh price, type, capacity, and stock at a glance before selecting one.
  function compareTable(units) {
    var top = units.slice(0, 3);
    var th = '<th style="text-align:left;padding:8px 10px;font-size:12px;color:#6b6355;font-weight:600"></th>';
    top.forEach(function (p, i) {
      th += '<th style="padding:8px 10px;text-align:left;border-left:1px solid #e4ddcf;vertical-align:bottom">' +
        (i === 0 ? '<span style="display:inline-block;background:#b8934a;color:#fff;font-size:10px;font-weight:700;border-radius:20px;padding:1px 7px;margin-bottom:4px">Recommended</span><br>' : '') +
        '<span style="font-weight:700;color:#0e1e3d;font-size:13px;line-height:1.25">' + esc(p.unit.title) + '</span></th>';
    });
    function row(label, cells) {
      var r = '<tr><td style="padding:7px 10px;font-size:12px;color:#6b6355;border-top:1px solid #f0ebe0">' + label + '</td>';
      cells.forEach(function (c) { r += '<td style="padding:7px 10px;font-size:13px;border-top:1px solid #f0ebe0;border-left:1px solid #e4ddcf">' + c + '</td>'; });
      return r + '</tr>';
    }
    var body =
      row('Price', top.map(function (p) { return '<strong>' + money(p.total) + '</strong>' + (p.qty > 1 ? ' <span style="color:#8a8171;font-size:11px">(' + p.qty + ' units)</span>' : ''); })) +
      row('Type', top.map(function (p) { return esc(p.unit.install || p.unit.vendor); })) +
      row('Rated capacity', top.map(function (p) { return p.unit.cuft.toLocaleString() + ' cu ft'; })) +
      row('Install', top.map(function (p) { return p.unit.tech ? 'HVAC-R technician' : 'Self / handyman'; })) +
      row('Availability', top.map(function (p) { return p.variant.available ? '<span style="color:#2f7d4f;font-weight:600">In stock</span>' : '<span style="color:#9a2b2b">Out of stock</span>'; }));
    return '<details class="calc-compare" style="margin:10px 0 4px"><summary style="cursor:pointer;font-size:13px;font-weight:600;color:#0e1e3d">Side-by-side comparison</summary>' +
      '<div style="overflow-x:auto;margin-top:8px"><table style="border-collapse:collapse;min-width:100%;background:#fff;border:1px solid #e4ddcf;border-radius:8px"><thead><tr>' + th + '</tr></thead><tbody>' + body + '</tbody></table></div></details>';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function today() {
    return new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  }
  function pick(form, k) { return form.querySelector('[data-q="' + k + '"]'); }
  function v(form, k) {
    var el = pick(form, k);
    if (!el) return null;
    return el.type === 'checkbox' ? el.checked : el.value;
  }
  function n(form, k) { return parseFloat(v(form, k)); }

  function readInput(form) {
    return {
      length: n(form, 'length'), width: n(form, 'width'), height: n(form, 'height'),
      ambient: n(form, 'ambient') || 75,
      rFactor: n(form, 'rfactor') || 0.055,
      vapourBarrier: pick(form, 'vapor') ? v(form, 'vapor') === true : true,
      glass: v(form, 'glass') === true,
      standardDoor: v(form, 'stddoor') === true,
      bottles: parseInt(v(form, 'bottles'), 10) || 0,
      preparedFor: (v(form, 'preparedfor') || '').trim(),
      jobRef: (v(form, 'jobref') || '').trim()
    };
  }

  function cartUrl(lines) {
    var p = root.WCCQuote.cartPath(lines);
    return p ? window.location.origin + p : null;
  }

  /* in-stock first; keep engine order within each group */
  function stockSort(arr, variantOf) {
    return arr.slice().sort(function (a, b) {
      return (variantOf(a).available ? 0 : 1) - (variantOf(b).available ? 0 : 1);
    });
  }

  /* ---- accessory fitment ------------------------------------------------ */
  var SERIES = ['SC PRO', 'EXTREME', 'PHANTOM', 'PLATINUM', 'SLIMLINE', 'QUANTUM', 'MINI'];
  var MAINT = /filter|replacement|bulb|\(4-?pack\)/i;
  /* brand-universal add-ons that carry no model list in the title */
  var GEN_WK = /condensate pump|uv-c|coil coating|pdt plus|thermostat/i;
  var GEN_BR = /temperature probe/i;

  function models(t) { return (String(t).toUpperCase().match(/\d{3,4}/g) || []); }
  function seriesOf(t) {
    t = String(t).toUpperCase();
    for (var i = 0; i < SERIES.length; i++) { if (t.indexOf(SERIES[i]) >= 0) return SERIES[i]; }
    return '';
  }
  function pickVariant(acc, uSeries) {
    var vs = acc.variants || [];
    if (!vs.length) return null;
    if (vs.length === 1) return vs[0];
    /* multi-variant accessories here are a SERIES choice (e.g. UV-C:
     * "SC PRO Series"/"Extreme Series"/"Slimline LS"); return the variant whose
     * series matches the unit, or null if none does — an accessory offered only
     * per series does not apply to a unit outside those series (e.g. Phantom).
     * Functional-variant accessories are excluded before this is called. */
    var seriesVariant = vs.filter(function (x) { return uSeries && seriesOf(x.title) === uSeries && x.available; });
    return seriesVariant.length ? seriesVariant[0] : null;
  }
  function variantsAreSeries(acc) {
    return (acc.variants || []).some(function (x) { return seriesOf(x.title); });
  }
  function matchAccessories(unit, list) {
    if (!unit || !list) return [];
    var uVendor = String(unit.vendor || '').toLowerCase();
    var uModels = models(unit.title), uSeries = seriesOf(unit.title);
    var out = [];
    list.forEach(function (a) {
      if (String(a.vendor || '').toLowerCase() !== uVendor) return;   // accessories are brand-specific here
      if (MAINT.test(a.title)) return;                                 // maintenance, not an install add-on
      if ((a.variants || []).length > 1 && !variantsAreSeries(a)) return; // ambiguous functional variants
      var paren = a.title.match(/\(([^)]*)\)/);
      var modelScoped = false;
      if (paren) {
        var aModels = models(paren[1]);
        if (aModels.length) {                                          // paren lists specific models → must fit
          modelScoped = true;
          if (!aModels.some(function (m) { return uModels.indexOf(m) >= 0; })) return;
          var aSeries = seriesOf(paren[1]) || seriesOf(a.title);
          if (aSeries && uSeries && aSeries !== uSeries) return;       // don't cross series
        }
        /* a paren with no model (e.g. "(Salt Air Protection)", "(Omega
         * Condenser)") is not fitment — fall through to the generic allowlist,
         * which keeps universal add-ons like coil coating and drops
         * condenser-specific ducting/enclosures we can't confirm. */
      }
      if (!modelScoped) {
        if (uVendor.indexOf('whisperkool') >= 0) { if (!GEN_WK.test(a.title)) return; }
        else if (uVendor.indexOf('breezaire') >= 0) { if (!GEN_BR.test(a.title)) return; }
        else return;                                                  // generic add-on, brand not in allowlist
      }
      var variant = pickVariant(a, uSeries);
      if (!variant || !variant.available) return;
      out.push({ acc: a, variant: variant });
    });
    return out;
  }

  var STYLE = '<style>' +
    '.calc-optgroup{display:flex;flex-direction:column;gap:8px;margin:8px 0 4px}' +
    '.calc-opt{display:flex;gap:12px;align-items:flex-start;border:1px solid #e2ddd2;border-radius:10px;padding:11px 13px;cursor:pointer;background:#fff;transition:border-color .12s,box-shadow .12s}' +
    '.calc-opt:hover{border-color:#c7ba98}' +
    '.calc-opt--sel{border-color:#8a6d3b;box-shadow:0 0 0 1px #8a6d3b;background:#fbf9f4}' +
    '.calc-opt--oos{opacity:.72}' +
    '.calc-opt input{margin-top:3px;flex:none;width:18px;height:18px;accent-color:#8a6d3b}' +
    '.calc-opt-body{flex:1 1 auto;min-width:0}' +
    '.calc-opt-name{font-weight:700}.calc-opt-name a{color:inherit;text-decoration:none}' +
    '.calc-opt-detail{font-size:.86rem;color:#5b5449;margin-top:2px;line-height:1.4}' +
    '.calc-opt-price{font-weight:700;white-space:nowrap;text-align:right}' +
    '.calc-opt-each{display:block;font-weight:400;font-size:.8em;color:#8a8072}' +
    '.calc-addons{margin-top:6px}.calc-addons-note{font-size:.82rem;color:#7a7264;margin:2px 0 0}' +
    '.calc-badge--rec{background:#8a6d3b;color:#fff}' +
    '.calc-badge--oos{background:#8c1c1c;color:#fff}' +
    '.calc-quote-add{background:#8a6d3b;color:#fff;border:0;border-radius:9px;padding:11px 22px;font:600 1rem system-ui,sans-serif;cursor:pointer;min-height:46px}' +
    '.calc-quote-add:hover{background:#75592d}.calc-quote-add:disabled{opacity:.7;cursor:default}' +
    '</style>';

  function optRow(group, i, checked, name, url, badges, detail, priceHtml, oos) {
    return '<label class="calc-opt' + (checked ? ' calc-opt--sel' : '') + (oos ? ' calc-opt--oos' : '') + '">' +
      '<input type="radio" name="' + group + '" value="' + i + '"' + (checked ? ' checked' : '') + '>' +
      '<span class="calc-opt-body"><span class="calc-opt-name"><a href="' + esc(url) + '">' + esc(name) + '</a></span> ' +
      badges + '<span class="calc-opt-detail">' + detail + '</span></span>' +
      '<span class="calc-opt-price">' + priceHtml + '</span></label>';
  }

  /* Add-ons that fit the currently selected unit. Rebuilt whenever the unit
   * changes because fitment depends on the model. All start unchecked — we
   * never pad the cart. */
  function renderAddons(out) {
    var wrap = out.querySelector('.calc-addons-wrap'); if (!wrap) return;
    var q = out._wccQ;
    var uEl = out.querySelector('input[name="wcc-unit"]:checked');
    if (!uEl || !q || !q._acc || !q._acc.length) { wrap.innerHTML = ''; out._wccMatch = []; return; }
    var m = matchAccessories(q._units[+uEl.value].unit, q._acc);
    out._wccMatch = m;
    if (!m.length) { wrap.innerHTML = ''; return; }
    var h = '<div class="calc-addons"><h3>Add-ons that fit this system <span class="calc-optional">optional</span></h3>' +
      '<p class="calc-addons-note">Compatible accessories for the selected unit. Add any you need — they join the same cart and quote.</p>' +
      '<div class="calc-optgroup">';
    m.forEach(function (x, i) {
      var vt = (x.variant.title && x.variant.title !== 'Default Title') ? esc(x.variant.title) : '';
      h += '<label class="calc-opt calc-opt--addon">' +
        '<input type="checkbox" name="wcc-addon" value="' + i + '">' +
        '<span class="calc-opt-body"><span class="calc-opt-name"><a href="' + esc(x.acc.url) + '">' + esc(x.acc.title) + '</a></span>' +
        (vt ? '<span class="calc-opt-detail">' + vt + '</span>' : '') +
        '</span><span class="calc-opt-price">' + money(x.variant.price) + '</span></label>';
    });
    h += '</div></div>';
    wrap.innerHTML = h;
  }

  function refreshQuote(out) {
    var q = out._wccQ, input = out._wccInput, d = out._wccData;
    var wrap = out.querySelector('.calc-quote-wrap'); if (!wrap) return;
    var uEl = out.querySelector('input[name="wcc-unit"]:checked');
    var rEl = out.querySelector('input[name="wcc-rack"]:checked');
    var top = uEl ? q._units[+uEl.value] : null;
    var r0 = rEl ? q._racks[+rEl.value] : null;
    if (!top) { wrap.innerHTML = ''; out._wccSheet = null; return; }

    var lines = [{ variantId: top.variant.id, qty: top.qty }];
    var sheetLines = [{ name: top.unit.title, qty: top.qty, total: top.total, detail: 'Rated ' + top.unit.cuft.toLocaleString() + ' cu ft each, covering ' + top.covered.toLocaleString() + ' cu ft' + (top.unit.tech ? '. HVAC-R technician required.' : '') }];
    var total = top.total;
    if (r0) {
      lines.push({ variantId: r0.variant.id, qty: r0.qty });
      sheetLines.push({ name: r0.rack.title, qty: r0.qty, total: r0.total, detail: r0.qty + ' racks holding ' + r0.capacity + ' bottles each, ' + r0.holds.toLocaleString() + ' in total' });
      total += r0.total;
    }
    var addons = [];
    var m = out._wccMatch || [];
    out.querySelectorAll('input[name="wcc-addon"]:checked').forEach(function (el) {
      var x = m[+el.value]; if (!x) return;
      addons.push(x);
      lines.push({ variantId: x.variant.id, qty: 1 });
      sheetLines.push({ name: x.acc.title, qty: 1, total: x.variant.price, detail: 'Add-on for the cooling system' + (x.variant.title && x.variant.title !== 'Default Title' ? ' · ' + x.variant.title : '') });
      total += x.variant.price;
    });
    var url = cartUrl(lines);
    var soldOut = !top.variant.available || (r0 && !r0.variant.available);
    var qr = '';
    if (url && root.WCCQR) { try { qr = '<div><div class="calc-qr">' + root.WCCQR.toSvg(url, { label: 'Cart link' }) + '</div><div class="calc-qr-cap">Scan to load this cart</div></div>'; } catch (e) { qr = ''; } }
    wrap.innerHTML = '<div class="calc-quote"><div class="calc-quote-grid"><div>' +
      '<div class="calc-fig-l">Your quote &middot; ' + esc(today()) + '</div>' +
      '<div class="calc-quote-total">' + money(total) + '</div>' +
      '<div class="calc-pick-detail">' + esc(top.unit.title) + ' &times; ' + top.qty +
      (r0 ? ' &middot; ' + esc(r0.rack.title) + ' &times; ' + r0.qty : '') +
      (addons.length ? ' &middot; ' + addons.length + ' add-on' + (addons.length > 1 ? 's' : '') : '') + '</div>' +
      '<div class="calc-quote-links">' +
      '<button class="calc-quote-add" data-addquote' + (soldOut ? ' disabled title="One item is out of stock"' : '') + '>' + (soldOut ? 'Out of stock' : 'Add quote to cart') + '</button>' +
      (url && !soldOut ? '<a class="calc-btn" href="' + url + '">Open in cart</a>' : '') +
      (url ? '<button class="calc-btn" data-copy="' + esc(url) + '">Copy cart link</button>' : '') +
      '<button class="calc-btn" data-print>Print quote</button></div>' +
      (url ? '<div class="calc-link-box">' + esc(url) + '</div>' : '') +
      '</div>' + qr + '</div></div>';
    out._wccSheet = { quote: q, input: input, data: d, lines: sheetLines, url: url };
  }

  function markSel(out) {
    ['wcc-unit', 'wcc-rack'].forEach(function (name) {
      out.querySelectorAll('input[name="' + name + '"]').forEach(function (inp) {
        var lab = inp.closest('.calc-opt'); if (lab) lab.classList.toggle('calc-opt--sel', inp.checked);
      });
    });
  }

  function render(out, q, input, d) {
    var tel = (d.phone || '').replace(/[^0-9]/g, '');
    q._units = stockSort(q.picks, function (p) { return p.variant; });
    q._racks = stockSort(q.racks, function (r) { return r.variant; });
    q._acc = d.accessories || [];
    out._wccQ = q; out._wccInput = input; out._wccData = d;

    var h = STYLE +
      '<div class="calc-figs">' +
      '<div class="calc-fig"><div class="calc-fig-v">' + q.volume.toLocaleString() + '</div><div class="calc-fig-l">Room volume, cu ft</div></div>' +
      '<div class="calc-fig"><div class="calc-fig-v">' + q.sizingVolume.toLocaleString() + '</div><div class="calc-fig-l">Sizing volume, cu ft</div><div class="calc-fig-n">We size against this</div></div>' +
      '<div class="calc-fig"><div class="calc-fig-v">~' + q.btu.toLocaleString() + '</div><div class="calc-fig-l">Est. BTU/hr</div><div class="calc-fig-n">A rough figure, not a load calculation</div></div></div>';

    if (q.allowances.length) {
      h += '<p class="calc-allow"><strong>Allowances we added:</strong> ' + esc(q.allowances.join('; ')) + '. Ours, not the manufacturer’s. Every published capacity assumes a sealed, insulated room.</p>';
    }

    h += '<div class="calc-picks"><h3>Cooling unit' + (q._units.length > 1 ? ' <span class="calc-optional">recommended selected — pick another to compare</span>' : '') + '</h3>';
    if (!q._units.length) {
      h += '<p class="calc-empty">No unit we stock covers this room, even three of them. Call <a href="tel:+1' + tel + '">' + esc(d.phone) + '</a> and we will size it by hand.</p>';
    } else {
      h += '<div class="calc-optgroup" role="radiogroup" aria-label="Cooling unit">';
      q._units.forEach(function (p, i) {
        var oos = !p.variant.available;
        var badges = (i === 0 ? '<span class="calc-badge calc-badge--rec">Recommended</span>' : '') +
          (oos ? '<span class="calc-badge calc-badge--oos">Out of stock</span>' : '') +
          (p.qty > 1 ? '<span class="calc-badge calc-badge--multi">' + p.qty + ' units</span>' : '') +
          (p.unit.tech ? '<span class="calc-badge calc-badge--tech">Technician required</span>' : '') +
          '<span class="calc-badge">' + esc(p.unit.install || p.unit.vendor) + '</span>';
        var detail = 'Rated ' + p.unit.cuft.toLocaleString() + ' cu ft each, covering ' + p.covered.toLocaleString() + ' cu ft' +
          (p.variant.title && p.variant.title !== 'Default Title' ? ' &middot; ' + esc(p.variant.title) : '') +
          (p.unit.tech ? '. A licensed HVAC-R technician must install this.' : '');
        var price = money(p.total) + (p.qty > 1 ? '<span class="calc-opt-each">' + money(p.variant.price) + ' each</span>' : '');
        h += optRow('wcc-unit', i, i === 0, p.unit.title, p.unit.url, badges, detail, price, oos);
      });
      h += '</div>';
      if (q._units.length > 1) h += compareTable(q._units);
    }
    h += '</div>';

    if (q._racks.length) {
      h += '<div class="calc-racks"><h3>Racking for ' + input.bottles.toLocaleString() + ' bottles' + (q._racks.length > 1 ? ' <span class="calc-optional">choose one</span>' : '') + '</h3><div class="calc-optgroup" role="radiogroup" aria-label="Racking">';
      q._racks.forEach(function (r, i) {
        var oos = !r.variant.available;
        var badges = (i === 0 ? '<span class="calc-badge calc-badge--rec">Recommended</span>' : '') + (oos ? '<span class="calc-badge calc-badge--oos">Out of stock</span>' : '');
        var detail = r.qty + ' racks holding ' + r.capacity + ' bottles each, ' + r.holds.toLocaleString() + ' in total';
        h += optRow('wcc-rack', i, i === 0, r.rack.title, r.rack.url, badges, detail, money(r.total), oos);
      });
      h += '</div></div>';
    }

    h += '<div class="calc-addons-wrap"></div>';
    h += '<div class="calc-quote-wrap"></div>';

    q.flags.forEach(function (f) { h += '<div class="calc-flag">' + esc(f) + '</div>'; });
    h += '<div class="calc-flag" style="background:#f4f4f4;border-left-color:#999"><strong>Priced ' + esc(today()) + '.</strong> Not a held price. Prices and stock move, so check both before you order. To have a specialist confirm the spec, call <a href="tel:+1' + tel + '">' + esc(d.phone) + '</a>, ' + esc(d.hours) + '.</div>';

    out.innerHTML = h;
    out.hidden = false;
    renderAddons(out);
    refreshQuote(out);
    gev('calculator_completed', {
      est_btu: loadBtu(q),
      room_volume: q.volume,
      recommended_unit: (q._units[0] && q._units[0].unit.title) || 'none',
      units_available: q._units.length,
      bottles: input.bottles
    });
  }

  function mount(opts) {
    var form = opts.form, out = opts.out;
    if (!form || !out || !root.WCCQuote) return;
    var d = data();
    if (!d) return;

    function run() {
      var input = readInput(form);
      if (!input.length || !input.width || !input.height) return false;
      render(out, root.WCCQuote.quote(input, d), input, d);
      if (opts.scroll !== false) out.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); run(); });
    if (opts.trigger) opts.trigger.addEventListener('click', function (e) { e.preventDefault(); run(); });

    out.addEventListener('change', function (e) {
      if (e.target.name === 'wcc-unit') { markSel(out); renderAddons(out); refreshQuote(out); }
      else if (e.target.name === 'wcc-rack') { markSel(out); refreshQuote(out); }
      else if (e.target.name === 'wcc-addon') { refreshQuote(out); }
    });

    out.addEventListener('click', function (e) {
      var addq = e.target.closest('[data-addquote]');
      if (addq) {
        if (!out._wccSheet || !out._wccSheet.lines) return;
        var uEl = out.querySelector('input[name="wcc-unit"]:checked'), rEl = out.querySelector('input[name="wcc-rack"]:checked');
        var q = out._wccQ, items = [];
        if (uEl) { var u = q._units[+uEl.value]; items.push({ id: Number(u.variant.id), quantity: Number(u.qty) }); }
        if (rEl) { var r = q._racks[+rEl.value]; items.push({ id: Number(r.variant.id), quantity: Number(r.qty) }); }
        var m = out._wccMatch || [];
        out.querySelectorAll('input[name="wcc-addon"]:checked').forEach(function (el) {
          var x = m[+el.value]; if (x) items.push({ id: Number(x.variant.id), quantity: 1 });
        });
        if (!items.length) return;
        var qval = 0;
        if (uEl) qval += Number(q._units[+uEl.value].total || 0);
        if (rEl) qval += Number(q._racks[+rEl.value].total || 0);
        out.querySelectorAll('input[name="wcc-addon"]:checked').forEach(function (el) { var x = m[+el.value]; if (x) qval += Number(x.variant.price || 0); });
        addq.disabled = true; var was = addq.textContent; addq.textContent = 'Adding…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error(r.status); addq.textContent = 'Added ✓ — view cart'; addq.onclick = function () { window.location.href = '/cart'; }; gev('add_to_quote', { value: Math.round(qval), currency: 'USD', items: items.length, unit: (uEl ? q._units[+uEl.value].unit.title : 'none') }); })
          .catch(function () { addq.textContent = was; addq.disabled = false; });
        return;
      }
      var cp = e.target.closest('[data-copy]');
      if (cp && navigator.clipboard) {
        navigator.clipboard.writeText(cp.dataset.copy).then(function () {
          var t = cp.textContent; cp.textContent = 'Copied'; setTimeout(function () { cp.textContent = t; }, 1500);
        });
        return;
      }
      if (e.target.closest('[data-print]') && out._wccSheet && root.WCCQuoteSheet) {
        root.WCCQuoteSheet.build(out._wccSheet);
        (function (done) {
          var sheet = document.querySelector('.wcc-sheet');
          var imgs = sheet ? Array.prototype.slice.call(sheet.querySelectorAll('img')) : [];
          var pending = imgs.filter(function (i) { return !i.complete || !i.naturalWidth; });
          if (!pending.length) { done(); return; }
          var fired = false, finish = function () { if (!fired) { fired = true; done(); } }, left = pending.length;
          pending.forEach(function (i) { var tick = function () { if (--left <= 0) finish(); }; i.addEventListener('load', tick, { once: true }); i.addEventListener('error', tick, { once: true }); });
          setTimeout(finish, 3000);
        })(function () { window.print(); });
      }
    });
    return { run: run };
  }

  root.WCCQuoteUI = { mount: mount, data: data };
})(window);
